
import { useLocation, useNavigate, useParams } from 'react-router-dom';

export const withRouter = (Component) => {
    return (props) => {
        const location = useLocation();
        const params = useParams()
        const navigate = useNavigate();
        return <Component {...props} history={{location:location, push:navigate, goBack: () => navigate(-1)}} match={{params:params}} location={location} navigate={navigate} />;
    };
};